import { type FC } from "react";

import { type RendererProps } from "../../../models/dimension-funnel";

import { LABEL_PADDING_LEFT, xAxisPoints, xAxisTickTitle } from "./engagementFunnel.styles";

export const CustomizedAxisTick: FC<RendererProps> = ({ index, payload }) => {
    if (typeof index !== "number") {
        throw new TypeError("Missing custom x-axis-tick index.");
    }
    return (
        <text
            x={(xAxisPoints[index] ?? 0) + LABEL_PADDING_LEFT}
            y={0}
            dy={16}
            textAnchor="start"
            className={xAxisTickTitle}
        >
            {payload?.value ?? ""}
        </text>
    );
};
